import { fmtTimestamp } from '@/lib/http'
import { plannedWrites, type RunSummary } from '@/lib/fieldCopy'
import { RunStatusBadge } from '@/pages/FieldCopy/RunReport'

/** Past runs, newest first; a click opens the run's report in the center. */
export function FieldCopyHistory({ runs, activeId, onOpen }: {
  runs: RunSummary[]
  activeId: number | null
  onOpen: (id: number) => void
}) {
  if (runs.length === 0) return <p className="text-[12.5px] text-text-2">No runs yet.</p>
  return (
    <ul className="space-y-0.5">
      {runs.map((r) => {
        const active = r.id === activeId
        const pairs = r.pairs.map((p) => `${p.source_name} → ${p.target_name}`).join('; ')
        return (
          <li key={r.id}>
            <button
              type="button"
              onClick={() => onOpen(r.id)}
              aria-label={`Open run ${r.id}`}
              aria-current={active ? 'true' : undefined}
              className={[
                'relative block w-full rounded-[5px] px-2 py-1.5 text-left transition-colors',
                active
                  ? 'bg-surface-selected before:absolute before:inset-y-0 before:left-0 before:w-0.5 before:rounded-l-[5px] before:bg-primary'
                  : 'hover:bg-surface-raised',
              ].join(' ')}
            >
              <span className="flex items-baseline gap-2">
                <span className="font-mono text-[12.5px] text-foreground">#{r.id}</span>
                <span className="truncate text-[12px] text-text-2">{r.actor}</span>
                <span className="ml-auto"><RunStatusBadge status={r.status} /></span>
              </span>
              <span className="block truncate text-[11.5px] text-text-2" title={pairs}>{pairs}</span>
              <span className="block truncate font-mono text-[11px] text-text-3" title={r.jql}>
                {r.issues_total} issues · {plannedWrites(r.counters)} writes · {fmtTimestamp(r.created_at)}
              </span>
            </button>
          </li>
        )
      })}
    </ul>
  )
}
